import React, { Component } from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import moment from "moment";
import Icon from "module-common/Icon";
import Avatar from "module-common/Avatar";
import LabelList from "module-common/label-list/LabelList";
import { Button } from "antd";
import ButtonGroup from "antd/lib/button/button-group";

export default class Row extends Component {
  
  render() {

    const {
      id,
      index,
      campaignName,
      content,
      status,
      tagList,
      onEdit,
      onSend,
      onDelete
    } = this.props;

    return (
      <Wrapper>
        <Index>{index}.</Index>
        <Name>
            {campaignName}
        </Name>
        <Name>
          {content}
        </Name>
        <Name>
          {status}
        </Name>
        <Name>
          {tagList.map(item => item.displayName).join(", ")}
        </Name>
        <Toolbox>
          <ButtonGroup>
            {status == 'draft' && <Button onClick={() => onEdit(this.props)}>Edit</Button>}
            {status == 'draft' && <Button onClick={() => onSend(this.props)}>Send</Button>}
            <Button type='danger' onClick={() => onDelete(this.props)}>Delete</Button>
          </ButtonGroup>
        </Toolbox>
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  width: auto;
  height: auto;
  display: flex;
  flex: none;
  border-bottom: 1px solid ${props => props.theme.panelBorder};
  align-items: center;
  padding: 10px;
  &:hover {
    background: #ececec;
    font-weight: 600;
    cursor: pointer;
  }
`;

const Index = styled.div`
  margin-left: 10px;
  flex: 1;
`;

const Name = styled.div`
  flex: 4;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const StyledAvatar = styled(Avatar)`
  margin-right: 10px;
`;

const Toolbox = styled.div`
  flex: 5;
`;

const IconSocial = styled(Icon)`
  flex: 2;
`;

const Label = styled.div`
  flex: 4;
  margin-right: 10px;
`;



// WEBPACK FOOTER //
// ./src/module-bulk-sms/campaign/Row.js